import axios from 'axios';
import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useHistory } from 'react-router';
import { Spinner, Alert } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const VerifyPage = () => {
    const history = useHistory();
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    const getUserInformation = async () => {
        const userId = localStorage.getItem('loggedin_user');
        await axios.get(`/api/users/${userId}`)
            .then((response) => {
                localStorage.setItem('user', JSON.stringify(response.data));
            })
            .catch((error) => {
                console.log({ error });
            });
    };

    const verify = async (email, token) => {
        setLoading(true);
        await axios.post('/api/email/verify', { email, token })
            .then(() => {
                getUserInformation();
                window.location = '/edit-profile';
            })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log({ error });
            }).finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        const queryStrings = queryString.parse(location.search);
        verify(queryStrings.email, queryStrings.token);
    }, []);

    return (
        <div className="container">
            <div className="section page-title">
                <div className="page-title-container">
                    <h1>Email Activation</h1>
                </div>
            </div>
            <div className="row" style={{ minHeight: '70vh' }}>
                {
                    loading ? (
                        <div className="col-md-12 text-center">
                            <Spinner animation="grow" variant="primary" />
                        </div>
                    )
                        : (
                            <div className="col-md-12">
                                <Alert variant="danger" dismissible={false}>
                                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                                    <p>
                                        You opened an invalid link.
                                    </p>
                                </Alert>
                            </div>
                        )
                }
            </div>
        </div>
    );
};

export default VerifyPage;
